import { render, staticRenderFns } from "./loadXlsx.vue?vue&type=template&id=f542f782&"
import script from "./loadXlsx.vue?vue&type=script&lang=js&"
export * from "./loadXlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports